export default __webpack_public_path__ + "static/media/commissioningAndInspection.e429b419.svg";